import { isNonNaNNumber } from '@iotv/iotv-v3-types'

/** returns true if x is same or higher that lo, and less than hi */
export const between = (x: number | undefined, lo: number, hi: number) => {
  return isNonNaNNumber(x) && x >= lo && x < hi
}

export const inDateTimeRange = (x: Date, lo: Date, hi: Date) => {
  return x && x >= lo && x < hi
}
